import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const threatconnect = defineConnector({
  identifier: "threatconnect",
  name: "ThreatConnect",
  tagLine: "Threat intelligence platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) => domainToRegex(baseUrl),
  auth: customAuth("threatconnect"),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In ThreatConnect, go to **My Profile → API Settings** and generate an access ID and secret key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Access ID",
          required: true,
          target: { kind: "configuration", field: "accessId" },
        },
        {
          kind: "input",
          label: "Secret key",
          required: true,
          target: { kind: "secrets", field: "secretKey" },
        },
        {
          kind: "url",
          label: "ThreatConnect base URL",
          placeholder: "https://app.threatconnect.com",
          required: true,
          target: { kind: "configuration", field: "baseUrl" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/api/v3/security/owners`,
  },
});
